import type { ReactElement, ReactNode } from 'react';

export type AdminCardErrorProps = {
  label: string;
  action?: ReactNode;
};

export function AdminCardError({ label, action }: AdminCardErrorProps): ReactElement {
  return (
    <div className="rounded-[var(--r-md)] border border-[var(--err)] bg-[var(--err-wash)] p-4 flex items-center justify-between gap-3">
      <span className="text-[12px] text-[var(--ink)]">
        Couldn&apos;t load {label}.
      </span>
      {action}
    </div>
  );
}
